// extracted by mini-css-extract-plugin
module.exports = {"container":"StructurePage_container__72ybV","title":"StructurePage_title__1vr1n","users":"StructurePage_users__2ub6O","list":"StructurePage_list__fJ5x6"};